import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import { DownloadOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import LeaveRightsReportModal from "../reportModal/LeaveRightsReportModal";
import LeaveRightsDetailReportModal from "../reportModal/LeaveRightsDetailModal";
import LeaveRightsReportIndividualModal from "../reportModal/LeaveRightsReportIndividualModal";
import dayjs from "dayjs";

const LeaveRightsReportComponent = ({
    initialValues,
    showReport,
    isModalOpen = false,
    isModalDetailOpen = false,
    isModalIndividualOpen = false,
    isDownload = false,
    positionOptions = [],
    departmentOptions = [],
    leaveGroupOptions = [],
    reportTableLeaveRights = [],
    selectedRecord,
    pagination,
    handleSearch = () => { },
    setIsModalOpen = () => { },
    setIsModalDetailOpen = () => { },
    setIsIndividualModalOpen = () => { },
    showModal = () => { },
    showModalDetail = () => { },
    showIndividualModal = () => { },
    exportLeaveQuotaReport = () => { },
    exportLeaveRightsReportByEmployee = () => { },
    onChange = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 130,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.nameEn + " " + record?.surNameEn;
                }
                return record?.name + " " + record?.surName
            },
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                return i18n.language === "en" ? record?.department?.organizationNameEn : record?.department?.organizationName;
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.position?.positionNameEn;
                }
                return record?.position?.positionName;
            },
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: "100px",
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        placement="bottomRight"
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => showModalDetail(record)}
                                        >
                                            {t("action.view_more")}
                                        </p>
                                    ),
                                    icon: (
                                        <EyeOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => showModalDetail(record)}
                                        />
                                    ),
                                },
                                {
                                    key: "2",
                                    label: (
                                        <p
                                            style={{ color: "grey", fontSize: "14px" }}
                                            onClick={() => showIndividualModal(record)}
                                        >
                                            {t("action.download")}
                                        </p>
                                    ),
                                    icon: (
                                        <DownloadOutlined
                                            style={{ fontSize: "18px", color: "gray" }}
                                            onClick={() => showIndividualModal(record)}
                                        />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        }
    ]

    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);

    return (
        <MainLayout>
            <LeaveRightsReportModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportLeaveQuotaReport={exportLeaveQuotaReport} isDownload={isDownload} />
            <LeaveRightsDetailReportModal isModalDetailOpen={isModalDetailOpen} setIsModalDetailOpen={setIsModalDetailOpen} reportTableLeaveRights={reportTableLeaveRights} selectedRecord={selectedRecord} />
            <LeaveRightsReportIndividualModal isModalIndividualOpen={isModalIndividualOpen} setIsIndividualModalOpen={setIsIndividualModalOpen} exportLeaveRightsReportByEmployee={exportLeaveRightsReportByEmployee} selectedRecord={selectedRecord} />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("leave-rights-group"), href: "" },
                        { title: t("report_leave_rights.header") }
                    ]} />
                    <h2>{t("report_leave_rights.header")}</h2>
                </Flex>

                <FormAntd
                    initialValues={{ ...initialValues, year: dayjs() }}
                    onFinish={handleSearch}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>

                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="leaveTypeId"
                                                        label={t('employee.label.request_type')}
                                                        options={leaveGroupOptions.map(option => ({ value: option.value, label: option.label }))}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        mode="multiple"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('translation.year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        required
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>
                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                    <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('report_leave_rights.header')}</span>
                                                    <TableAntd
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                        columns={columns}
                                                        dataSource={reportTableLeaveRights}
                                                        rowKey={(record) => record.id}
                                                        scroll={{ x: scrollX }}
                                                        tableLayout="fixed"
                                                    />
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}

                    </FormItem>
                </FormAntd>

            </Space>
        </MainLayout>
    )
}

export default LeaveRightsReportComponent;